// src/components/Footer.js
import React, { useEffect, useState } from "react";
import { useNavigate, Link, useParams } from 'react-router-dom';



export default function Footer() {
    return (
        <footer className="bg-white border-t">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="flex flex-col lg:flex-row justify-between gap-10">
                    {/* Left Section */}
                    <div className="space-y-4">
                        <img
                            src="assets/youvati_logo.png"
                            alt="Youvati Logo"
                            className="h-10 w-auto"
                        />
                        <p className="text-sm text-gray-600 font-semibold">
                            Your Success Saathi
                        </p>

                        <div className="flex gap-4">
                            <a
                                href="https://www.facebook.com/youvatiofficial/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="assets/facebook_icon.png"
                                    className="h-7 w-7"
                                    alt="Facebook"
                                />
                            </a>
                            <a
                                href="https://www.instagram.com/youvatiofficial?igsh=MXd2aTFkY29laGt5ZQ=="
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="assets/insta_icon.png"
                                    className="h-7 w-7"
                                    alt="Instagram"
                                />
                            </a>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-10 text-sm font-medium">
                        <Link href="#privacy" className="hover:text-[#38357A] font-semibold">
                            Privacy & Policy
                        </Link>
                        <Link to="/" className="hover:text-[#38357A] font-semibold">
                            Home
                        </Link>
                        <Link to="" className="hover:text-[#38357A] font-semibold">
                            Terms & Condition
                        </Link>
                        <Link to="/partnerpage" className="hover:text-[#38357A] font-semibold">
                            Partner with us
                        </Link>
                        <Link to="/aboutus" className="hover:text-[#38357A] font-semibold">
                            About us
                        </Link>
                    </div>
                </div>

                {/* Bottom Line */}
                <div className="mt-8 border-t pt-6 text-xs text-gray-600 font-semibold text-center lg:text-left">
                    ©2025. Able Edutech Pvt. Ltd. All rights reserved.
                </div>
            </div>
        </footer>
    );
}
